module.exports = "/_next/static/images/andhra_curry-af1c0f06e836ec00b775d30ad758c5fd.jpg";